import { render } from "./descriptionComponent.vue?vue&type=template&id=8c2e0d0e&scoped=true"
import script from "./descriptionComponent.vue?vue&type=script&lang=js"
export * from "./descriptionComponent.vue?vue&type=script&lang=js"

import "./descriptionComponent.vue?vue&type=style&index=0&id=8c2e0d0e&scoped=true&lang=css"

import exportComponent from "/home/app-corporate-consiliumplus/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c2e0d0e"]])

export default __exports__